<template>
    <div
        :class="{
            'current-lang-avatar': avatar,
            'big-avatar': avatar && avatarSize === 'big',
            'small-avatar': avatar && avatarSize === 'small',
        }"
        :style="!blacklist[country] ? null : `background-color: ${blacklist[country].color}`"
    >
        <country-flag v-if="!blacklist[country]" :country="country" :size="size" />
        <div v-else class="w-100 h-100 d-flex align-items-center justify-content-center">
            <h6 class="country-text subtitle font-weight-600 mb-0 white">
                {{ blacklist[country].label }}
            </h6>
        </div>
    </div>
</template>

<script>
import CountryFlag from 'vue-country-flag';

export default {
    name: 'FlagIcon',
    components: { CountryFlag },
    props: {
        country: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            default: 'normal',
        },
        avatar: Boolean,
        avatarSize: {
            type: String,
            default: 'big',
        },
    },
    data: () => ({
        blacklist: {
            // Blacklists some countrycodes to use text instead of flags. (God dammit, Northern Ireland...)
            gb: { label: 'EN', color: '#00247D' },
            chn: { label: 'CN', color: '#DE2910' },
        },
    }),
};
</script>

<style scoped>
.current-lang-avatar {
    overflow: hidden;

    border-radius: 50%;
    font-size: 1.25rem;

    background-color: #bdbdbd;
    color: white;

    cursor: pointer;
    position: relative;
}

.big-avatar {
    width: 40px;
    height: 40px;
    border: 3px solid #bdbdbd;
    box-sizing: border-box;
}

.big-avatar > span {
    position: absolute;
    top: -15px;
    left: -15px;
    /*  background-position: -655px -270px !important; */
}

.small-avatar {
    width: 32px;
    height: 32px;
}

.small-avatar > span {
    position: absolute;
    top: -16px;
    left: -16px;
    /* background-position: -656px -271px !important; */
}

.country-text {
    font-weight: 600 !important;
    text-transform: uppercase;
}
</style>
